import React, { useState, useEffect } from "react"
import Layout from "../../components/layouts/layout"
import PropTypes from "prop-types"
import "./patientinfo.css"
import validation from "./validation"
import { format } from "date-fns"
import DatePicker from "react-datepicker"
import { useTrackFormStepArrival } from "../../utils/analytics"
import ContinueButton from "components/elements/styledButton/ContinueButton"
import ProgressBar from "utils/stepper"
import MorningApptBanner from "utils/morningApptBanner"

const Patientform = ({
  analyticsPayload,
  nextStep,
  prevStep,
  setAnalyticsPayload,
  setUser,
  user,
}) => {
  const [nextBtn, setNextbtn] = useState(false)
  const [errbirthdate, setBb] = useState(false)
  var [startDate, setStartDate] = useState(user.newdatebirth)
  const [errField, setErrField] = useState({
    address1Err: "",
    address2Err: "",
    cityErr: "",
    countryErr: "",
    genderErr: "",
    lastNameErr: "",
    nameErr: "",
    birthdateErr: "",
    stateErr: "",
    zipCodeErr: "",
  })

  useTrackFormStepArrival("patient_form_info")

  const validForm = () => {
    return validation.validatePatientForm(setErrField, user)
  }
  const handleChange = e => {
    // const formattedDate = format(e, "MM/dd/yyyy")
    if (e === null) {
      return false
    } else {
      if (isNaN(Date.parse(e))) {
        validation.validateWelcomeVisitBadDate(e, setErrField, setUser, user)
      } else {
        if (format(e, "yyyy") < 2000) {
          setStartDate((startDate = null))
          setBb(true)
        } else {
          setBb(false)
          setStartDate((startDate = e))
          const formattedDate = format(e, "MM/dd/yyyy")
          setUser({
            ...user,
            birthdate: formattedDate,
            newdatebirth: e,
          })
        }
      }
    }
  }

  const handleSubmit = e => {
    e && e.preventDefault()
    analyticsPayload.campaign = e.target && e.target.elements.campaign.value
    analyticsPayload.campaignStacking =
      e.target && e.target.elements.campaignStacking.value
    analyticsPayload.gaclientid = e.target && e.target.elements.gaclientid.value
    analyticsPayload.gclid = e.target && e.target.elements.gclid.value
    analyticsPayload.medium = e.target && e.target.elements.medium.value
    analyticsPayload.source = e.target && e.target.elements.source.value
    console.log(e.target && e.target.elements)
    // if (validForm()) {
    if (startDate) {
      const formattedDate = format(startDate, "MM/dd/yyyy")
      setUser({
        ...user,
        birthdate: formattedDate,
        newdatebirth: startDate,
      })
      if (validForm()) {
        console.log(user, "analytics payload:", analyticsPayload)
        nextStep()
      }
    } else {
      let formIsvalid = true
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        birthdateErr: "please enter birth date.",
      }))
      return formIsvalid
    }
    // console.log(user)
    // nextStep()
    // }
  }

  useEffect(() => {
    if (startDate) {
      nextCheck(user)
    } else {
      setNextbtn(false)
    }
  }, [user, startDate])

  const nextCheck = user => {
    if (
      !user.name ||
      !user.lastName ||
      !user.city ||
      !user.country ||
      !user.state ||
      !user.zipCode ||
      !user.address1 ||
      !user.gender
    ) {
      setNextbtn(false)
    } else {
      if (
        user.zipCode.length >= 5 &&
        format(user.newdatebirth, "yyyy") >= 2000
      ) {
        setNextbtn(true)
      } else {
        setNextbtn(false)
      }
    }
  }
  const myStyle = {
    backgroundImage: "url(../images/caret-down.svg)",
  }
  return (
    <>
      <Layout>
        <section className="progress-bar-section">
          <div className="progress-bar-wrapper">
            <ProgressBar activeStep={0} />
          </div>
        </section>
        <MorningApptBanner />
        <section className="patient-information-section">
          <div className="container">
            <div className="patient-heading">
              <h4>Patient Information</h4>
            </div>

            <form
              className="patient-formSection"
              data-form_type="self-schedule"
              onSubmit={handleSubmit}
            >
              <input data-fieldName="campaign" name="campaign" type="hidden" />
              <input data-fieldName="medium" name="medium" type="hidden" />
              <input data-fieldName="source" name="source" type="hidden" />
              <input
                data-fieldName="campaignStacking"
                name="campaignStacking"
                type="hidden"
              />
              <input
                data-fieldName="gaclientid"
                name="gaclientid"
                type="hidden"
              />
              <input data-fieldName="gclid" name="gclid" type="hidden" />
              <div className="patient-wrapper">
                <div className="patient-form-wrapper">
                  <div className="pat-form-heading">
                    <h4>Patient Details</h4>
                  </div>
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="firstname">
                        First Name<span>Required*</span>
                      </label>
                      <input
                        className="form-control"
                        id="firstname"
                        name="name"
                        onChange={handleChange}
                        placeholder="E.g - John"
                        type="text"
                        value={user.name}
                      />
                      {!user.name && (
                        <span className="input-error">{errField.nameErr}</span>
                      )}
                    </div>

                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="lastname">
                        Last Name<span>Required*</span>
                      </label>
                      <input
                        className="form-control"
                        id="lastname"
                        name="lastName"
                        onChange={handleChange}
                        placeholder="E.g - Doe"
                        type="text"
                        value={user.lastName}
                      />

                      {!user.lastName && (
                        <span className="input-error">
                          {errField.lastNameErr}
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="gender_selector">
                        Gender<span>Required*</span>
                      </label>
                      <select
                        className="form-select form-control"
                        id="gender_selector"
                        name="gender"
                        onChange={handleChange}
                        style={myStyle}
                        value={user.gender}
                      >
                        <option disabled value="">
                          Select Gender
                        </option>
                        <option value="Cisgender Female">Female</option>
                        <option value="Cisgender Male"> Male</option>
                        <option value="Agender">Agender</option>
                        <option value="Bigender">Bigender</option>
                        <option value="Genderfluid">Genderfluid</option>
                        <option value="Nonbinary">Nonbinary</option>
                        <option value="Transgender">Transgender</option>
                        <option value="Gender Nonconforming">
                          Gender Nonconforming
                        </option>
                        <option value="Other">Other</option>
                        <option value="Decline to Specify">
                          Decline to Specify
                        </option>
                      </select>
                      {!user.gender && (
                        <span className="input-error">
                          {errField.genderErr}
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="birthdate">
                        Birthdate<span>Required*</span>
                      </label>
                      <DatePicker
                        className="form-control"
                        dateFormat="MM/dd/yyyy"
                        dropdownMode="scroll"
                        id="birthdate"
                        maxDate={new Date()}
                        name="birthdate"
                        onChange={handleChange}
                        placeholderText={"MM/DD/YYYY"}
                        scrollableYearDropdown={true}
                        selected={startDate}
                        showMonthDropdown
                        showYearDropdown
                        yearDropdownItemNumber={22}
                      />
                      {errbirthdate && (
                        <span className="input-error">Year is Invalid</span>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 patient-subheading">
                      <h5>Patient Address</h5>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="address1input">
                        Address 1<span>Required*</span>
                      </label>
                      <input
                        className="form-control"
                        id="address1input"
                        name="address1"
                        onChange={handleChange}
                        placeholder="1234 Street Name"
                        type="text"
                        value={user.address1}
                      />

                      {!user.address1 && (
                        <span className="input-error">
                          {errField.address1Err}
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="address2input">
                        Address 2<span>Optional*</span>
                      </label>
                      <input
                        className="form-control"
                        id="address2input"
                        name="address2"
                        onChange={handleChange}
                        placeholder="Apartment, Suite, P.O Box #"
                        type="text"
                        value={user.address2}
                      />

                      {!user.address2 && (
                        <span className="input-error">
                          {errField.address2Err}
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="cityinput">
                        City<span>Required*</span>
                      </label>
                      <input
                        className="form-control"
                        id="cityinput"
                        name="city"
                        onChange={handleChange}
                        placeholder="City"
                        type="text"
                        value={user.city}
                      />

                      {!user.city && (
                        <span className="input-error">{errField.cityErr}</span>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="state_selector">
                        State<span>Required*</span>
                      </label>
                      <select
                        className="form-select form-control"
                        id="state_selector"
                        name="state"
                        onChange={handleChange}
                        style={myStyle}
                        value={user.state}
                      >
                        <option disabled value="">
                          Select State
                        </option>
                        <option value="AL">Alabama</option>
                        <option value="AK">Alaska</option>
                        <option value="AS">American Samoa</option>
                        <option value="AZ">Arizona</option>
                        <option value="AR">Arkansas</option>
                        {/* <option value="Baker Island">Baker Island</option> */}
                        <option value="CA">California</option>
                        <option value="CO">Colorado</option>
                        <option value="CT">Connecticut</option>
                        <option value="DE">Delaware</option>
                        <option value="DC">District of Columbia</option>
                        <option value="FL">Florida</option>
                        <option value="GA">Georgia</option>
                        <option value="Guam">Guam</option>
                        <option value="HI">Hawaii</option>
                        {/* <option value="HoI">Howland Island</option> */}
                        <option value="ID">Idaho</option>
                        <option value="IL">Illinois</option>
                        <option value="IN">Indiana</option>
                        <option value="IA">Iowa</option>
                        {/* <option value="JI">Jarvis Island</option>
                        <option value="JA">Johnston Atoll</option> */}
                        <option value="KS">Kansas</option>
                        <option value="KY">Kentucky</option>
                        {/* <option value="KR">Kingman Reef</option> */}
                        <option value="LA">Louisiana</option>
                        <option value="ME">Maine</option>
                        <option value="MD">Maryland</option>
                        <option value="MA">Massachusetts</option>
                        <option value="MI">Michigan</option>
                        <option value="MiA">Midway Atoll</option>
                        <option value="MN">Minnesota</option>
                        <option value="MS">Mississippi</option>
                        <option value="MO">Missouri</option>
                        <option value="MT">Montana</option>
                        {/* <option value="NaI">Navassa Island</option>
                        <option value="NE">Nebraska(NE)</option> */}
                        <option value="NV">Nevada</option>
                        <option value="NH">New Hampshire</option>
                        <option value="NJ">New Jersey</option>
                        <option value="NM">New Mexico</option>
                        <option value="NY">New York</option>
                        <option value="NC">North Carolina</option>
                        <option value="ND">North Dakota</option>
                        <option value="NMI">Northern Mariana Islands</option>
                        <option value="Ohio">Ohio</option>
                        <option value="OK">Oklahoma</option>
                        <option value="OR">Oregon</option>
                        {/* <option value="PA">Palmyra Atoll</option> */}
                        <option value="PA">Pennsylvania</option>
                        <option value="PR">Puerto Rico</option>
                        <option value="RI">Rhode Island</option>
                        <option value="SC">South Carolina</option>
                        <option value="SD">South Dakota</option>
                        <option value="TN">Tennessee</option>
                        <option value="TX">Texas</option>
                        <option value="USVI">US Virgin Islands</option>
                        <option value="UT">Utah</option>
                        <option value="VT">Vermont</option>
                        <option value="VA">Virginia</option>
                        {/* <option value="WI">Wake Island</option> */}
                        <option value="WA">Washington</option>
                        <option value="WV">West Virginia</option>
                        <option value="WIS">Wisconsin</option>
                        <option value="WY">Wyoming</option>
                      </select>

                      {!user.state && (
                        <span className="input-error">{errField.stateErr}</span>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="country_selector">
                        Country<span>Required*</span>
                      </label>
                      <select
                        className="form-select form-control"
                        id="country_selector"
                        name="country"
                        onChange={handleChange}
                        value={user.country}
                      >
                        <option disabled value="">
                          Select a Country
                        </option>
                        <option value="USA">United States of America</option>
                      </select>

                      {!user.country && (
                        <span className="input-error">
                          {errField.countryErr}
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="zipCodeinput">
                        Zip Code<span>Required*</span>
                      </label>
                      <input
                        className="form-control"
                        id="zipCodeinput"
                        name="zipCode"
                        onChange={handleChange}
                        placeholder="E.g. 90001"
                        type="text"
                        value={user.zipCode}
                      />

                      {!user.zipCode && (
                        <span className="input-error">
                          {errField.zipCodeErr}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="btn-wrapper mt-4">
                  <button
                    className="btn btnclose"
                    onClick={prevStep}
                    type="button"
                  >
                    Go Back
                  </button>
                  <ContinueButton disabled={!nextBtn} type="submit">
                    Next Step
                  </ContinueButton>
                </div>
                <div className="btn-wrapper mt-4 text-end"></div>
              </div>
            </form>
          </div>
        </section>
      </Layout>
    </>
  )
}
Patientform.propTypes = {
  analyticsPayload: PropTypes.object.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  setAnalyticsPayload: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}
export default Patientform
